import React, { useEffect, useState } from 'react';
import { apiGet, apiPost, apiPut, apiDelete } from '../../../shared/utils/apiConfig';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import { motion } from 'framer-motion';
import { AiOutlineProduct } from 'react-icons/ai';
import { FaArrowLeft, FaImage } from 'react-icons/fa';

import {
  productsRecord,
  clearState,
} from '../../../redux/Slices/ProductsSlice';
import { useTitle } from '../../../context/TitleContext';
import axios from 'axios';
import { showSuccessToast, showErrorToast, showWarningToast, showInfoToast } from '../../../shared/utils/toastHelper';

const ViewProduct = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const { setTitle } = useTitle();

  const { record, isLoading } = useSelector((state) => state.products);

  useEffect(() => {
    setTitle("المنتجات");
  }, [setTitle]);
  useEffect(() => {
    dispatch(clearState());
    if (id) {
      dispatch(productsRecord(id));
    }
  }, [dispatch, id]);
  const [productData, setProductData] = useState(null);

  useEffect(() => {
    if (record) {
      setProductData(record);
    }
  }, [record]);
  const BASE_URL = process.env.REACT_APP_BASE_URL;

  const toggleStatus = async (
    { product_id, unit_id, color_id },
    updateLocal
  ) => {
    try {
      const user = JSON.parse(sessionStorage.getItem("storekhadamat"));
      const token = user?.token;

      const payload = { product_id };
      if (unit_id) payload.unit_id = unit_id;
      if (color_id) payload.color_id = color_id;

      await apiPost('/products/store_toggle_product_status', payload);

      updateLocal();
      showSuccessToast("تم تغيير الحالة");
      dispatch(productsRecord(id));
    } catch (error) {
      showErrorToast("فشل تغيير الحالة");
    }
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <div>
              {" "}
              <h4 style={{ fontSize: "1.1rem", margin: 0 }}>
                {" "}
                <AiOutlineProduct
                  className="mx-2"
                  style={{ fontSize: "1.5rem", color: "#6b7280" }}
                />{" "}
                مشاهدة المنتج
              </h4>
            </div>
            <div>
              <Link to="/view-products" className="text-decoration-none mx-3">
                <motion.button
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  className="btn btn-outline-secondary btn-sm"
                  style={{ borderRadius: "8px" }}
                >
                  العودة
                  <FaArrowLeft className="mx-2" />
                </motion.button>
              </Link>
            </div>
          </div>

          <div className="card p-3">
            {!id ? (
              <div className="text-center text-danger">لا يوجد معرف (ID)</div>
            ) : isLoading ? (
              <div className="text-sm">جاري التحميل...</div>
            ) : !record ? (
              <div className="text-center text-danger">المنتج غير موجود</div>
            ) : (
              <div className="card-body">
                <div className="row">
                  <div className="col-md-12">
                    <div className="d-flex justify-content-between">
                      <h5 className="main-color" style={{ fontSize: "18px" }}>
                        بيانات المنتج
                      </h5>
                      <div className="form-check form-switch">
                        <input
                          type="checkbox"
                          className="mx-1"
                          checked={!!productData?.status}
                          onChange={() =>
                            toggleStatus({ product_id: productData.id }, () => {
                              setProductData((prev) => ({
                                ...prev,
                                status: !prev.status,
                              }));
                            })
                          }
                        />
                        <label className="form-check-label text-sm">
                          تغيير الحالة
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <hr />
                  </div>
                  <div className="col-md-6">
                    <b className="text-sm d-block">
                      <i className="bi bi-caret-left-fill main-color"></i> الاسم{" "}
                    </b>
                    <span className="bg-light rounded border d-block p-2 my-3 text-sm">
                      {record?.name}
                    </span>
                  </div>
                  <div className="col-md-6">
                    <b className="text-sm d-block">
                      <i className="bi bi-caret-left-fill main-color"></i> الوصف{" "}
                    </b>
                    <span className="bg-light rounded border d-block p-2 my-3 text-sm">
                      {record?.description}
                    </span>
                  </div>
                  {/* عرض السعر فقط (بدون حقل الخصم) */}
                  <div className="col-md-6">
                    <b className="text-sm d-block">
                      <i className="bi bi-caret-left-fill main-color"></i> السعر
                    </b>
                    <span className="bg-light rounded border d-block p-2 my-3 text-sm">
                      {record?.discounted_price} جنيه
                    </span>
                  </div>
                  <div className="col-md-12">
                    <h5 className="main-color" style={{ fontSize: "18px" }}>
                      صور المنتج
                    </h5>
                    <hr />
                  </div>
                  <div className="col-md-12">
                    {record?.product_images &&
                    record?.product_images.length > 0 ? (
                      <div className="row">
                        {record?.product_images.map((img) => (
                          <div className="col-md-3" key={img.id}>
                            <div className="border p-2 rounded-3 my-2">
                              <img
                                src={img?.image_url || "/user.webp"}
                                alt="--"
                                style={{
                                  width: "100px",
                                  height: "100px",
                                  objectFit: "cover",
                                }}
                                className="mx-auto d-block"
                                onError={(e) => (e.target.src = "/user.webp")}
                              />
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : record?.first_image_url ? (
                      <div className="row">
                        <div className="col-md-3">
                          <div className="border p-2 rounded-3 my-2">
                            <img
                              src={record.first_image_url}
                              alt="صورة المنتج"
                              style={{
                                width: "100px",
                                height: "100px",
                                objectFit: "cover",
                              }}
                              className="mx-auto d-block"
                              onError={(e) => (e.target.src = "/user.webp")}
                            />
                          </div>
                        </div>
                      </div>
                    ) : (
                      <span className="bg-light rounded border d-block p-2 my-3 text-sm text-center">
                        <FaImage className="main-color text-lg" />
                        <span className="d-block my-2">لا يوجد صور</span>
                      </span>
                    )}
                  </div>
                  <div className="col-md-12">
                    <hr />
                    <h5
                      className="main-color mb-3"
                      style={{ fontSize: "18px" }}
                    >
                      الوحدات
                    </h5>
                  </div>
                  <div className="col-md-12">
                    {productData?.units && productData?.units.length > 0 && (
                      <div className="row">
                        {productData?.units.map((unit) => (
                          <div className="col-md-12" key={unit.id}>
                            <div className="d-flex justify-content-between">
                              <b className="text-sm d-block my-2">
                                <i className="bi bi-caret-left-fill main-color"></i>{" "}
                                الوحدة رقم ({unit.id})
                              </b>
                              <div className="form-check form-switch">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  role="switch"
                                  id={`unit-${unit.id}`}
                                  checked={!!unit.status}
                                  onChange={() =>
                                    toggleStatus(
                                      {
                                        product_id: productData.id,
                                        unit_id: unit.id,
                                      },
                                      () => {
                                        setProductData((prev) => ({
                                          ...prev,
                                          units: prev.units.map((u) =>
                                            u.id === unit.id
                                              ? { ...u, status: !u.status }
                                              : u
                                          ),
                                        }));
                                      }
                                    )
                                  }
                                />

                                <label className="form-check-label text-sm">
                                  تغيير الحالة
                                </label>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-md-4">
                                <div className="border bg-light p-2 rounded-3 my-2">
                                  <span className="text-sm">
                                    السعر :{" "}
                                    <small className="text-success">
                                      {unit.price} جنيه
                                    </small>
                                  </span>
                                </div>
                              </div>
                              <div className="col-md-4">
                                <div className="border bg-light p-2 rounded-3 my-2">
                                  <span className="text-sm">
                                    الكمية :{" "}
                                    <small className="text-primary">
                                      {unit.quantity} قطعة
                                    </small>
                                  </span>
                                </div>
                              </div>
                              <div className="col-md-4">
                                <div className="border bg-light p-2 rounded-3 my-2">
                                  <span className="text-sm">
                                    نوع الوحدة :{" "}
                                    <small className="text-info">
                                      {unit.unit_type}
                                    </small>
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="my-2">
                              <div className="row">
                                <div className="col-md-12">
                                  <div className="row">
                                    <div className="col-md-3">
                                      <div className="bg-light border rounded-3 my-2 py-1 px-3">
                                        <span className="text-sm">
                                          لون الوحدة : {""}
                                          <ul className="list-unstyled p-0 mb-0 d-flex">
                                            {unit?.colors &&
                                              unit?.colors.length > 0 &&
                                              unit?.colors.map((color) => (
                                                <li
                                                  key={color?.id}
                                                  className="rounded-3 pt-2 mx-1 my-2 text-white text-xs text-center"
                                                  style={{
                                                    height: "30px",
                                                    width: "30px",
                                                    backgroundColor: `${color?.color_code}`,
                                                  }}
                                                >
                                                  ({color?.id})
                                                </li>
                                              ))}
                                          </ul>
                                        </span>
                                      </div>
                                    </div>
                                    <div className="col-md-3">
                                      <div className="bg-light border rounded-3 my-2 py-1 px-3">
                                        {unit?.colors &&
                                          unit?.colors.length > 0 &&
                                          unit?.colors.map((color) => (
                                            <span
                                              className="text-sm"
                                              key={color?.id}
                                            >
                                              سعر الوحدة : ({color?.id})
                                              <small className="d-block my-2 text-success">
                                                {color?.price} جنيه
                                              </small>
                                            </span>
                                          ))}
                                      </div>
                                    </div>
                                    <div className="col-md-3">
                                      <div className="bg-light border rounded-3 my-2 py-1 px-3">
                                        {unit?.colors &&
                                          unit?.colors.length > 0 &&
                                          unit?.colors.map((color) => (
                                            <span
                                              className="text-sm"
                                              key={color?.id}
                                            >
                                              كمية الوحدة : ({color?.id})
                                              <small className="d-block my-2 text-primary">
                                                {color?.quantity} قطعة
                                              </small>
                                            </span>
                                          ))}
                                      </div>
                                    </div>
                                    <div className="col-md-3">
                                      <div className="border bg-light p-2 rounded-3 my-2">
                                        <span className="text-sm d-block">
                                          تغيير الحالة :{" "}
                                        </span>
                                        {unit?.colors?.map((color) => (
                                          <div
                                            key={color.id}
                                            className="d-flex align-items-center justify-content-between"
                                          >
                                            <div className="form-check form-switch">
                                              <input
                                                className="form-check-input"
                                                type="checkbox"
                                                role="switch"
                                                id={`color-${color.id}`}
                                                checked={!!color.status}
                                                onChange={() =>
                                                  toggleStatus(
                                                    {
                                                      product_id:
                                                        productData.id,
                                                      unit_id: unit.id,
                                                      color_id: color.id,
                                                    },
                                                    () => {
                                                      setProductData(
                                                        (prev) => ({
                                                          ...prev,
                                                          units: prev.units.map(
                                                            (u) =>
                                                              u.id === unit.id
                                                                ? {
                                                                    ...u,
                                                                    colors:
                                                                      u.colors.map(
                                                                        (c) =>
                                                                          c.id ===
                                                                          color.id
                                                                            ? {
                                                                                ...c,
                                                                                status:
                                                                                  !c.status,
                                                                              }
                                                                            : c
                                                                      ),
                                                                  }
                                                                : u
                                                          ),
                                                        })
                                                      );
                                                    }
                                                  )
                                                }
                                              />
                                            </div>

                                            <small
                                              key={color.id}
                                              className={`d-block text-center my-2 ${
                                                color.status
                                                  ? "bg-success text-white px-2 py-1 rounded-5 text-xs"
                                                  : "bg-primary text-white px-2 py-1 rounded-5 text-xs"
                                              }`}
                                            >
                                              {color.status
                                                ? "مفعل"
                                                : "غير مفعل"}{" "}
                                              ({color.id})
                                            </small>
                                          </div>
                                        ))}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-md-12">
                                  <hr />
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewProduct;
